module.exports = {
	"id": "UZ",
	"name": "Uzbekistan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.145297,
			"5": 0.060931,
			"6": 0.009374,
			"7": 0.014061,
			"8": 0.037496,
			"9": 0.032809,
			"10": 0.070305,
			"11": 0.065618,
			"12": 0.149984,
			"13": 0.060931,
			"14": 0.065618,
			"15": 0.032809,
			"16": 0.196854,
			"17": 0.126549,
			"18": 0.084366,
			"19": 0.079679,
			"20": 0.089053,
			"21": 0.107801,
			"22": 0.135923,
			"23": 0.089053,
			"24": 0.107801,
			"25": 0.070305,
			"26": 0.107801,
			"27": 0.084366,
			"28": 0.065618,
			"29": 0.014061,
			"30": 0.04687,
			"31": 0.079679,
			"32": 0.018748,
			"33": 0.032809,
			"34": 0.04687,
			"35": 0.070305,
			"36": 0.051557,
			"37": 0.037496,
			"38": 0.089053,
			"39": 0.243724,
			"40": 0.210915,
			"41": 0.037496,
			"42": 0.051557,
			"43": 0.131236,
			"44": 0.023435,
			"45": 0.192167,
			"46": 0.056244,
			"47": 0.089053,
			"48": 0.074992,
			"49": 2.231012,
			"50": 0.079679,
			"51": 0.32809,
			"52": 0.473387,
			"53": 15.078079,
			"54": 4.654191,
			"55": 0.065618,
			"56": 0.023435,
			"57": null
		},
		"firefox": {
			"2": 0.131236,
			"3": 0.098427,
			"4": 0.032809,
			"5": 0.023435,
			"6": 0.018748,
			"7": 0.014061,
			"8": 0.004687,
			"9": 0.028122,
			"10": 0.014061,
			"11": 0.051557,
			"12": 0.023435,
			"13": 0.04687,
			"14": 0.04687,
			"15": 0.014061,
			"16": 0.060931,
			"17": 0.032809,
			"18": null,
			"19": 0.028122,
			"20": 0.084366,
			"21": 0.004687,
			"22": 0.070305,
			"23": 0.028122,
			"24": 0.032809,
			"25": 0.028122,
			"26": 0.051557,
			"27": 0.004687,
			"28": null,
			"29": 0.018748,
			"30": 0.037496,
			"31": 0.018748,
			"32": 0.014061,
			"33": 0.009374,
			"34": 0.023435,
			"35": 0.028122,
			"36": 0.04687,
			"37": 0.028122,
			"38": 0.079679,
			"39": 0.037496,
			"40": 0.107801,
			"41": 0.032809,
			"42": 0.028122,
			"43": 0.201541,
			"44": 0.032809,
			"45": 0.056244,
			"46": 0.065618,
			"47": 0.4687,
			"48": 0.262472,
			"49": 2.615346,
			"50": 0.009374,
			"51": null,
			"52": 0.004687,
			"3.5": 0.342151,
			"3.6": 0.787416
		},
		"opera": {
			"9": null,
			"11": 0.042183,
			"12": 0.403082,
			"15": 0.042183,
			"16": 0.004687,
			"17": null,
			"18": 0.023435,
			"19": 0.023435,
			"20": 0.065618,
			"21": 0.014061,
			"22": 0.004687,
			"23": 0.014061,
			"24": null,
			"25": 0.070305,
			"26": 0.014061,
			"27": 0.206228,
			"28": 0.004687,
			"29": 0.009374,
			"30": 0.028122,
			"31": 0.107801,
			"32": 0.018748,
			"33": 0.009374,
			"34": 0.032809,
			"35": 0.037496,
			"36": 0.23435,
			"37": 0.056244,
			"38": 0.04687,
			"39": 0.065618,
			"40": 1.785747,
			"41": 0.248411,
			"42": 0.004687,
			"43": null,
			"9.5-9.6": 0.018748,
			"10.0-10.1": 0.112488,
			"10.5": 0.028122,
			"10.6": 0.084366,
			"11.1": 0.060931,
			"11.5": 0.107801,
			"11.6": 0.4687,
			"12.1": 1.326421
		},
		"safari": {
			"0": null,
			"4": 0.056244,
			"5": 0.112488,
			"6": 0.023435,
			"7": 0.014061,
			"8": 0.023435,
			"9": 0.023435,
			"10": 0.224976,
			"3.1": 0.028122,
			"3.2": 0.009374,
			"5.1": 0.131236,
			"6.1": 0.023435,
			"7.1": null,
			"9.1": 0.107801
		},
		"ios_saf": {
			"8": 0,
			"10": 3.32686700083,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0896552160699,
			"8.1-8.4": 0.165634212739,
			"9.0-9.2": 0.0790181565362,
			"9.3": 1.20553341382
		},
		"android": {
			"3": 0,
			"4": 0.10676796124,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.013345995155,
			"4.1": 0.38512728876,
			"4.2-4.3": 0.962818221899,
			"4.4": 2.20780891279,
			"4.4.3-4.4.4": 2.22687462016
		},
		"ie": {
			"6": 0.0197714640199,
			"7": 0.00988573200993,
			"8": 0.514058064516,
			"9": 0.321286290323,
			"10": 0.341057754342,
			"11": 0.780972828784,
			"5.5": null
		},
		"op_mob": {
			"0": 0.508927563903,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0141368767751
		},
		"edge": {
			"12": 0.028122,
			"13": 0.070305,
			"14": 0.084366
		},
		"ie_mob": {
			"10": 0.0565722253521,
			"11": 0.230329774648
		},
		"bb": {
			"7": 0.00398475,
			"10": null
		},
		"samsung": {
			"0": 3.336564
		},
		"and_uc": {
			"0": 16.167459
		},
		"op_mini": {
			"0": 6.85669255932
		},
		"and_chr": {
			"0": 13.562902
		},
		"and_ff": {
			"0": 0.026565
		}
	},
	"total": 93.261689884
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/UZ.json
 ** module id = 674
 ** module chunks = 0
 **/